// extracted by mini-css-extract-plugin
module.exports = {"headerContainer":"Header_headerContainer__LfSwl","addWidgetButton":"Header_addWidgetButton__SSc53","dashboardTabs":"Header_dashboardTabs__26sJE","active":"Header_active__1UvcT"};